import React, { FC } from "react";
import PageResult from "~/common/types/PageResult";
import FeatureFlagProvider from "~/common/contexts/FeatureFlagProvider";
export default (Component: FC) => ({
  featureFlags,
  ...rest
}: PageResult) => <FeatureFlagProvider featureFlags={featureFlags}>
      <Component {...rest} />
    </FeatureFlagProvider>;